<template>
  <section class="container">
    <section class="common_box">
      <p class="common_title">当前园区</p>
      <section class="cur_location">
        <img
          class="location"
          :src="require(`../../assets/images/icon_location_${common.theme}.png`)"
        />
        <span>{{common.marketInfo.marketName}}</span>
      </section>
    </section>
    <!-- 最近访问 -->
    <section class="common_box label_box" v-if="historyMess.length">
      <p class="common_title">最近访问</p>
      <section class="labels">
        <span class="label_item" @click="itemClick(item)" v-for="item in historyMess" :key="item.marketName">{{item.marketName}}</span>
      </section>
    </section>
    <!-- 项目数据 -->
    <section class="common_box label_box data_box" v-for="(item,index) in common.marketList" :key="index">
      <p class="common_title title_type" v-if="item.frameworkName">{{item.frameworkName}}</p>
      <section class="labels">
        <span class="label_item" @click="itemClick(cur)" v-for="cur in item.cityMarkets" :key="cur.marketName">{{cur.marketName}}</span>
      </section>
    </section>
  </section>
</template>
<script>
import util from "../../utils/util";
import storage from '../../utils/storage';
import { mapState,mapActions } from "vuex";
import {getUserMarketInfo} from "../../utils/api";
export default {
  name: "selectMarket",
  data() {
    return {
      historyMess:[]
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    let historyMess = JSON.parse(storage.get("historyMess"+this.common.cityId) || '[]');
    this.historyMess = historyMess;
    console.log(JSON.stringify(this.common.marketList))
  },
  methods: {
    ...mapActions(['getMarketInfo','getUserInfo','getTenantInfo','getTenantInfoList','getTheme','getHolidayStyle']),
    itemClick(item){
      console.log(item)
      // 如果选择的是当前选中的，直接回到首页
      if(item.marketId === this.common.marketInfo.id){
        this.$router.go(-1)
        return;
      }
      // 设置历史纪录
      let historyMess = JSON.parse(storage.get("historyMess"+this.common.cityId) || '[]');
      if(historyMess.length > 0){
        for(var i=0;i<historyMess.length;i++){
          if(historyMess[i].marketId == item.marketId || i == 3){
            historyMess.splice(i,1);
          }
        }
      }
      historyMess.unshift(item);
      storage.set("historyMess"+this.common.cityId,JSON.stringify(historyMess));
      this.getUserMarketInfo(item.marketId)
      // this.getMarketInfo(item)
    },
    getUserMarketInfo(marketId){
      getUserMarketInfo({},{marketId:marketId}).then(res=>{
        console.log(res)
        if(res.res && res.res.code === 10000 && res.body){
          if (res.body.tbMarketInfo) {
              this.getMarketInfo(res.body.tbMarketInfo);
              this.getTheme(res.body.tbMarketInfo.styleType);//设置全局主题色
              this.getHolidayStyle(res.body.tbMarketInfo.holidayStyle);//设置全局主题色
            }
            if (res.body.userInfo) {
              this.getUserInfo(res.body.userInfo);
            }else{
              this.getUserInfo({});
            }
            if (res.body.userTenantInfo) {
              this.getTenantInfo(res.body.userTenantInfo);
            }else{
              this.getTenantInfo({});
            }
            if (res.body.userTenantInfoList && res.body.userTenantInfoList.length) {
              this.getTenantInfoList(res.body.userTenantInfoList);
            }else{
              this.getTenantInfoList([])
            }
            setTimeout(()=>{this.$router.go(-1)},200)
        }else{
          util.showToast('项目信息获取失败')
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  min-height: 100vh;
}
.common_box {
  border-bottom: 14px solid #eee;
  padding: 28px;
  .common_title {
    font-size: 24px;
    color: rgba(153, 153, 153, 1);
    line-height: 34px;
    margin-bottom: 14px;
  }
  .title_type{
    color:#333;
    font-size:32px;
    font-weight: bold;
  }
  .cur_location {
    .flex();
    height: 44px;
    align-items: center;
    img {
      display: block;
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }
    span {
      font-size: 32px;
      font-weight: bold;
      color: #000;
    }
  }
  .labels {
    .flex();
    flex-wrap: wrap;
    padding-top: 14px;
    .label_item {
      min-width: 140px;
      padding: 0 28px;
      height: 68px;
      background: rgba(244, 244, 244, 1);
      border-radius: 4px;
      line-height: 68px;
      text-align: center;
      display: block;
      margin-right: 20px;
      margin-bottom: 20px;
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
  }
}
.label_box {
  padding-bottom: 8px;
}
.data_box{
  border:0;
}
</style>
